import BigNumber from 'bignumber.js';

export const fractionFormatter = (value: number, fraction?: number): string => {
  return new BigNumber(value).toFixed(fraction ?? 1);
};
